import PlusIcon from "@/assets/icons/plus.svg?react";
import SearchIcon from "@/assets/icons/search.svg?react";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

type EmptyStateProps = {
  title?: string;
  subTitle?: string;
  buttonText?: string;
  onSubmit: () => void;
};
function EmptyState({
  title = "No projects found",
  subTitle = "You have no work created yet",
  buttonText = "Create new job",
  onSubmit,
}: EmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <div className="mb-5 rounded-md border border-solid border-gray-200 p-[14px]">
        <SearchIcon />
      </div>
      <Typography variant="text-lg" weight="semibold" className="mb-2 text-gray-900">
        {title}
      </Typography>
      <Typography variant="text-small" className="mb-8 text-gray-600">
        {subTitle}
      </Typography>
      <Button size="lg" onClick={onSubmit}>
        <PlusIcon className="stroke-white" />
        {buttonText}
      </Button>
    </div>
  );
}

export default EmptyState;
